import { Link } from 'react-router-dom'
import { FaEnvelope, FaLocationDot, FaPhone } from 'react-icons/fa6'
import EmailLink from '../common/EmailLink'
import { logo } from '../../assets/images'
import { footerProductLinks } from '../../data/productsCatalogData'
import { company, navLinks } from '../../data/siteData'
import { openTel } from '../../utils/contactLinks'

function Footer() {
  return (
    <footer className="site-footer corp-footer">
      <div className="container">
        <div className="row g-4 align-items-start corp-footer__grid">
          <div className="col-12 col-lg-4 corp-footer__brand">
            <Link className="footer-brand footer-brand--flex" to="/" aria-label={`${company.name} home`}>
              <div className="footer-brand__mark">
                <img src={logo} alt="" aria-hidden="true" />
                <div className="footer-brand__wordmark">
                  <span className="footer-brand__primary">{company.brandPrimary}</span>
                  <span className="footer-brand__secondary">{company.brandSecondary}</span>
                </div>
              </div>
              <span className="footer-brand__legal">{company.name}</span>
            </Link>
            <p className="footer-brand__desc">
              Professional metal trading, sourcing and supply solutions with quality-driven
              operations from Gujarat.
            </p>
          </div>
          <div className="col-6 col-lg-2 corp-footer__links">
            <h3>Quick Links</h3>
            <ul>
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-6 col-lg-3 corp-footer__links">
            <h3>Our Products</h3>
            <ul>
              {footerProductLinks.map((item) => (
                <li key={item.slug}>
                  <Link to={`/products#${item.slug}`}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-12 col-lg-3 footer-contact-col corp-footer__contact">
            <h3>Contact</h3>
            <ul className="footer-contact-list">
              <li className="footer-contact-item">
                <FaLocationDot className="footer-contact-item__icon" aria-hidden="true" />
                <address className="footer-contact-item__text">{company.factoryAddress}</address>
              </li>
              <li className="footer-contact-item">
                <a
                  className="footer-contact-item__link"
                  href={company.tel}
                  onClick={(event) => openTel(company.phone, event)}
                >
                  <FaPhone className="footer-contact-item__icon" aria-hidden="true" />
                  <span className="footer-contact-item__text">+91 {company.phone}</span>
                </a>
              </li>
              <li className="footer-contact-item">
                <EmailLink className="footer-contact-item__link" email={company.email}>
                  <FaEnvelope className="footer-contact-item__icon" aria-hidden="true" />
                  <span className="footer-contact-item__text">{company.email}</span>
                </EmailLink>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {company.name}. All rights reserved.</span>
          <span>Quality metals. Reliable supply. Professional execution.</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
